import React from 'react';
import css from './LiveScansSection.module.css';
import { useHistory } from 'react-router-dom';
import slide1 from './images/slide1.png';
import slide2 from './images/slide2.png';
import slide3 from './images/slide3.png';
import slide4 from './images/slide4.png';

const LiveScansSection = ({}) => {
  const history = useHistory();
  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <div className={css.textWrapper}>
          <p className={css.title}>Live scan requests</p>
          <p className={css.subtitle}>Find your next project.</p>
          <p className={css.description}>
            Every day, new 3d scanning requests are added to the ScanWow marketplace — from heritage
            landmarks and film sets to construction sites. Whether you're a scanner looking for paid
            projects or a client seeking specialist data capture, this is where connections start.
          </p>
          <p className={css.listTitle}>How it works:</p>

          <ul>
            <li>Browse live requests by location, category, or budget.</li>
            <li>View details, files, or site references.</li>
            <li>Accept the request and connect directly with the project owner.</li>
          </ul>

          <i className={css.italic}>Only verified members can post or accept scan requests.</i>

          <button type="button" onClick={() => history.push('/coming-soon')} className={css.cta}>
            <span>{'View Live Scan Requests'}</span>
          </button>
        </div>

        <div className={css.carouselWrapper}>
          <div className={css.carousel}>
            <div className={css.carouselTrack}>
              <div className={css.carouselSlideWrapper}>
                <img src={slide1} alt="Slide 1" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide2} alt="Slide 2" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide3} alt="Slide 3" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide4} alt="Slide 4" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide1} alt="Slide 1" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide2} alt="Slide 2" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide3} alt="Slide 3" className={css.carouselSlide} />
              </div>
              <div className={css.carouselSlideWrapper}>
                <img src={slide4} alt="Slide 4" className={css.carouselSlide} />
              </div>
            </div>
          </div>

          <button type="button" onClick={() => history.push('/coming-soon')} className={css.cta2}>
            <span>{'Post a new request'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LiveScansSection;
